<template>
  <div></div>
</template>

<script>
export default {
  name: 'BlankView'
}
</script>